import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const GetSmsTemplateByTemplate = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.GetSmsTemplateByTemplate,
   method: RequestType.POST,
   data,
 }); 
 const UpsertSms = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.UpsertSms,
   method: RequestType.POST,
   data,
 }); 
 const TriggerSms = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.TriggerSms,
   method: RequestType.POST,
   data,
 }); 

 const SmsTemplateCommand = {
  GetSmsTemplateByTemplate ,
  UpsertSms,
  TriggerSms
  }
  
  export default SmsTemplateCommand;